<template> 
    <div class="input-view"
    :style="{margin:margin}">
        <span>{{title}}</span>
        <input 
            :value="value"
            :placeholder="placeholder"
            :clearable="true"
            @input="change"
            :type="type"
            />
    </div> 
</template>
<script> 
export default {
  props:{
      value:{
          type:String,
          default:""
      },
      title:{
          type:String,
          default:""
      },
      placeholder:{
          type:String,
          default:""
      },
      type:{
          type:String,
          default:"text"
      },
      margin:{
          type:String,
          default:"0 0 0 0"
      }
  },
  data() {
    return { 
        input:""
    };
  },
  computed: {
  }, 
  methods: {
      close(){
          this.$emit("close",{})
      },
      change(e) {
        let val = e.target.value;
        this.$emit("input", val);
      },
  },
  mounted() {
  }
};
</script>
<style scoped lang="less">

.input-view{
    display: flex;
    align-items: center;

    span{
        display: block;
        width: 40px;
    }

    input{
        width: 190px;
        outline:none;
        padding: 6px 4px;
    }
}
</style>
